import styled from 'styled-components';

export default styled.div`
  display: block;
  margin-top: 3rem;
`;
